<p-drawer [visible]="showClientSidebar()" (onHide)="CloseSidebar()" [showCloseIcon]="false" position="right" [dismissible]="false" [appendTo]="'body'"
  [blockScroll]="true" styleClass="w-12 xl:w-11 no-header xl:overflow-hidden border-none p-0 lg:overflow-hidden overflow-y-auto client-info-sidebar">
  <!-- Row -->
  <ng-template #headless>
  <fitness-force-client-profile [clientId]="activeClientId()" [interactionId]="interactionId()" [activeTab]="activeTab()" 
    (closeClientSidebar)="closeClientSidebar($event)" />
  </ng-template>
  <!-- Row -->
</p-drawer>